import callCmAPI from 'services/helpers/call-cm-api'

/******************
 * Fetch from API *
 ******************/

export const getResendEmail = (userEmail) =>
  callCmAPI(`/mail/activation/${userEmail}`, {
    method: 'get',
  })
    .then((res) => res.data)
    .catch((err) => console.error(err))
